var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2348_2390",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.256836,
    width: 27.822,
    height: 27.822,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2348_2390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15527 21.424V19.6852H14.4914V21.424H3.15527ZM3.15527 15.7504V14.0116H8.6394V15.7504H3.15527ZM3.15527 10.0768V8.33795H8.6394V10.0768H3.15527ZM23.9593 21.4464L19.4739 16.9944C19.0325 17.3154 18.5513 17.5599 18.0304 17.7278C17.5095 17.8958 16.98 17.9797 16.442 17.9797C14.9895 17.9797 13.7514 17.4722 12.7276 16.4571C11.7039 15.442 11.192 14.2089 11.192 12.7576C11.192 11.3063 11.7041 10.0731 12.7284 9.05802C13.7527 8.04294 14.9914 7.5354 16.4447 7.5354C17.8979 7.5354 19.1358 8.04294 20.1583 9.05802C21.1808 10.0731 21.6921 11.3044 21.6921 12.752C21.6921 13.29 21.6081 13.8195 21.4402 14.3404C21.2722 14.8613 21.024 15.3388 20.6956 15.7727L25.181 20.2247L23.9593 21.4464ZM16.442 16.2409C17.4174 16.2409 18.2464 15.9028 18.9291 15.2266C19.6119 14.5503 19.9532 13.7273 19.9532 12.7576C19.9532 11.7878 19.6119 10.9648 18.9291 10.2886C18.2464 9.61236 17.4174 9.27425 16.442 9.27425C15.4667 9.27425 14.6377 9.61236 13.9549 10.2886C13.2722 10.9648 12.9308 11.7878 12.9308 12.7576C12.9308 13.7273 13.2722 14.5503 13.9549 15.2266C14.6377 15.9028 15.4667 16.2409 16.442 16.2409Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageSearch);
export default __webpack_public_path__ + "static/media/manage_search.5d6d9d75de8b47905538fd2d6b00aa6f.svg";
export { ForwardRef as ReactComponent };